<template>

  <div v-loading="isLoading">
    <div class="clearfix large-icons mb-4  text-center">
      <span class="cadastro-title">{{centrocusto.user_name}} - {{centrocusto.nome}}</span>
      <i class="icon-close pull-right clickable" style="" @click="emitClose()"></i>
    </div>

    <table class="table table-striped table-bordered table-respostas table-sm">
      <tr v-for="resposta in centrocusto.respostas" :key="resposta.id">
        <td class="align-middle">
          <span>{{resposta.label}}</span>
        </td>
        <td>
          <cleave v-model="resposta.valor" :options="optionsInput" class="form-control text-right" ></cleave>
        </td>
      </tr>
    </table>
    <el-footer>
      <el-col class="pt-4">
        <el-button type="primary" class="pull-right" @click="salvar()">Salvar</el-button>
      </el-col>
    </el-footer>
  </div>
</template>

<script>
  import Cleave from 'vue-cleave-component'
  import {mapState, mapActions, mapGetters} from 'vuex'

  export default {
    name: "resposta-list",
    props: {
      centrocusto: {required: true}
    },
    components:{ Cleave},
    data() {
      return {
        isLoading: false,
        optionsInput: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalMark: ',',
          delimiter: '.'
        }
      }
    },
    methods: {
      ...mapActions('Seeder', ['updateRespostas']),
      emitClose() {
        this.$emit('update:centrocustoid')
      },
      async salvar() {
        this.isLoading = true
        const respostas = collect(this.centrocusto.respostas)
        const respostasAjustadas = respostas.filter(function (item) {
            return ! _.isNull(item.valor)
        }).map(item => _.pick(item, ['pergunta_id', 'valor', 'centro_custo_id'])).all()
        await this.updateRespostas({respostas: respostasAjustadas})
        this.isLoading = false
        this.$notify.success("Respostas Atualizadas com sucesso.")
        this.emitClose()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Seeder/RespostaList.vue